// Restored from production OTA 2026-08-21 (module 1410). Sent as the Basic-auth
// password to the /googleapi function; it ships inside the app bundle.
export default "U2FsdGVkX19iEiSttwYylK8Lx1If+4OI1Ntw/rGlx5dqBgiJt9rpxEJ+ePTlj+U/t/QQJiQ/2mEO/FXkUUdn6w==";
